module.exports = __webpack_public_path__ + "media/icons/star-7120fc9a.svg";